import { Enum } from './index';

export interface __FileAttachment {
    alt?: string;
    id: number;
    image: string;
    avatar: string;
    size?: string;
    name?: string;
    file?: string;
    video?: string;
    workspace?: number;
}

export interface __Enum {
    id: number;
    title: string;
}

export interface __Market {
    id: string;
    name: string;
    symbol: string;
    weeklyPriceLog: number[];
    sellPrice: number;
    buyPrice: number;
    changeOf24HourAmount: number;
    changeOf24HourPercent: number;
    inDollarPrice: number;
}

export interface __FiatType {
    id: string,
    name: string,
    symbol: string,
    iconUrl: string,
    sellPrice: number,
    buyPrice: number,
    sellDiscount: number,
    buyDiscount: number,
    minTradeAmount: number,
    isActive: boolean
}

export interface __GetAllCoinType {
    id?: string;
    name: string;
    symbol: string;
    isSellActive?: boolean;
    isBuyActive?: boolean;
    type?: {
        id: number;
        title: string;
    };
    iconUrl?: string;
    decimalTradeNumber?: number;
}

export interface __Order {
    id: string;
    trackingCode: string;
    pair: {
        base: string;
        quote: string;
    };
    side: __Enum;
    state: __Enum;
    type: __Enum;
    destinationQuantity: number;
    sourceQuantity: number;
    createdOn: string;
    commission: 0;
    onPrice: 0;
}

export interface __OrderTransaction {
    orderTransactionState: __Enum;
    orderTransactionType: __Enum;
    sourceAmount: number;
    id: string;
    destinationAmount: number;
    sourceSymbol: string;
    destinationSymbol: string;
    orderTransactionTrackingCode: string;
    createdOn: string;
}

export interface __Transaction {
    trackingCode: string;
    market: {
        id: string;
        symbol: string;
        name: string;
    };
    amount: number;
    type: __Enum;
    state: __Enum;
    createdAt: string;
    network: {
        name: string;
        fee: number;
        network: string;
    };
    paymentIdentifier: string;
    voucher: {
        batchNumber: string;
        voucherCode: string;
        voucerhActivationCode: string;
    };
    txId: string;
    bankAccount: {
        id: string;
        cardNumber: string;
        iBan: string;
        bankName: string;
    };
    commission: number;
    wallet: {
        walletAddress: string;
        memo: string;
    };
    balanceAfterTransaction: number;
    onPrice: number;
    digitalReceipt: string;
}

export interface __Wallet {
    assets: __Asset[];
    usdtBalance: number;
    irtBalance: number;
    withdrawalEnable: boolean;
    withdrawalDisableTill: string;
}

export interface __Asset {
    id: string;
    name: string;
    symbol: string;
    balance: number;
    available: number;
    onTrade: number;
    value: number;
    isDepositEnable: boolean;
    isWidthrawEnable: boolean;
    isTradeEnable: boolean;
    priority: number;
    lastPrice: number;
}

export interface __BankAccount {
    id: string;
    cardNumber: string;
    iBan: string;
    state: Enum;
    bank?: {
        code: string;
        name: string;
    };
}

export enum __WalletActions {
    Mine,
    Deposit,
    Withdrawal,
}

export interface __Level {
    id?: string;
    name?: string;
    uniqueName?: Enum;
    description?: string;
    sumDaysStayInLevel?: number;
    maxIrtWithdrawal?: number;
    maxCryptoWithdrawal?: number;
    minDepositIrtForUpgrade?: number;
    upgradeRequestState?: number;
    rejectUpgradeMessage?: string;
    resetMonthly?: boolean;
    ip?: string;
    createdOn?: string;
}

export interface __CashInSettings {
    depositId: string;
    iBan: string;
    accountNumber: string;
    bankName: string;
    bankAccountOwner: string;
}

export interface __MarketPriceBySymbol {
    cryptoDollarPrice: number;
    cryptoIrtBuyPrice: number;
    cryptoIrtSellPrice: number;
}

export interface __CardToCardSettings {
    service: number,
    cardNumber: string,
    ownerName: string,
    bankName: string,
    iBan: string,
    accountNumber: string,
    isActive: boolean

}

export interface __OfflineDepositSettings {
    bankName: string;
    iBan: string;
    bankAccountNumber: string;
    cardNumber: string;
    ownerName: string;
    isDepositActive: boolean;
}

export interface __RequestWithdrawalResult {
    transactionId: string;
    tracking: string;
    isTwoStepActive: boolean;
    withdrawalCommission: number;
}

export interface __WithdrawalResult {
    trackingCode: string;
    bankAccount: {
        id: string;
        cardNumber: string;
        iBan: string;
        bankName: string;
    };
    amount: number;
    state: Enum;
}

export interface __NetworksTypes {
    addressRegex: string;
    asset: string;
    depositDescription: string;
    depositEnabled: boolean;
    isWithdrawEnabled: boolean;
    isDefault: boolean;
    memoRegex: string;
    name: string;
    network: string;
    withdrawFee: number;
    withdrawMin: number;
    depositMin: number;
    withdrawMax: number;
}

export interface __NetworksApiResponse {
    symbol: string;
    networks: __NetworksTypes[];
    withdrawPrecision: number;
}

export interface __OfflineDepositActivation {
    isActive: boolean;
    minimumDepositAmount: number;
    minimumLevelForOfflineDeposit: __Enum;
}

export interface __TwoFaQrCode {
    recoveryCodes: string[];
    qrCodeUrl: string;
    authenticatorKey: string;
}

export interface __DepositNetwork {
    network: string;
    name: string;
    regex: string;
    depositEnabled: boolean;
    widthrawEnabled: boolean;
    memoRegex: string;
    widthrawFee: number;
    walletAddress: string;
    walletTag: string;
    qrCodeUrl: string;
    minDeposit: string;
}

export interface __ReferralInfo {
    code: string;
    balance: number;
    referralLevelTitle: string;
    referralLevelRewardPercent: number;
    totalBalance: number;
    lastModifiedDate: string;
    createdOn: string;
    userCount: number;
    authenticatedUsersCount: number;
    actionCount: number;
    fullName: string;
    phoneNumber: string;
}

export interface __ReferralAction {
    amount: number;
    createdOn: string;
    balanceAfterTransaction: number;
}

export interface __ReferralInvitedUser {
    createdOn: string;
    phoneNumber: string;
    levelTitle: string;
}

export interface __Notification {
    id: string;
    title: string;
    fullName: string;
    userId: string;
    link: string;
    isRead: boolean;
    readedTime: string;
    createdOn: string;
    message: string;
    reason: Enum;
}

export interface __Ticket {
    id: string;
    ticketNumber: string;
    title: string;
    state: Enum;
    createdOn: string;
}

export interface __TicketById {
    id: string;
    ticketNumber: string;
    title: string;
    state: Enum;
    ticketMessages: {
        sender: string;
        text: string;
        createdOn: string;
        attachmentUrl: string;
        files: {
            fileByteContent: string[];
        };
        isSystemAnswer: boolean;
    }[];
    createdOn: string;
    lastModifiedDate: string;
}

export interface __LevelOne {
    nationalCode: string;
    fullName: string;
    fatherName: string;
    birthDate: string;
    firstName: string;
    lastName: string;
    gender: string;
    email: string;
    isWaitingForAdmin:boolean;
}

export interface __UUSDOrderResult {
    voucherCode?: string;
    voucherActivationCode?: string;
    paymentUrl?: string;
    trackingCode: string;
    amount?: string;
    state: Enum;
}

export interface __OrderTransactionDetail {
    sourceSymbol: string;
    destinationSymbol: string;
    destinationAmount: number;
    sourceAmount: number;
    deposit: {
        amount: number;
        txId: string;
        symbol: string;
        trackingCode: string;
        voucher: {
            batchNumber: string;
            voucherCode: string;
            voucerhActivationCode: string;
        };
        network: {
            name: string;
            fee: number;
            network: string;
        };
        receptMedia: {
            id: string;
            name: string;
            contentType: string;
            fileName: string;
        };
        transactionState: __Enum;
        transactionType: __Enum;
        wallet: {
            walletAddress: string;
            memo: string;
        };
        bankAccount: {
            id: string;
            cardNumber: string;
            iBan: string;
            bankName: string;
        };
        paidAt: string;
        digitalReceipt: string;
    };
    withdrawal: {
        amount: number;
        txId: string;
        symbol: string;
        trackingCode: string;
        voucher: {
            batchNumber: string;
            voucherCode: string;
            voucerhActivationCode: string;
        };
        network: {
            name: string;
            fee: number;
            network: string;
        };
        receptMedia: {
            id: string;
            name: string;
            contentType: string;
            fileName: string;
        };
        transactionState: __Enum;
        transactionType: __Enum;
        wallet: {
            walletAddress: string;
            memo: string;
        };
        bankAccount: {
            id: string;
            cardNumber: string;
            iBan: string;
            bankName: string;
        };
        paidAt: string;
        digitalReceipt: string;
    };
    orderTransactionState: __Enum;
    orderTransactionType: __Enum;
    orderTransactionTrackingCode: string;
    attachedMessage: string;
    createdOn: string;
    onPrice: number;
}

export interface __LevelDetail {
    createdOn: string;
    description: string;
    id: string;
    ip: string;
    maxCryptoWithdrawal: number;
    maxIrtWithdrawal: number;
    minDepositIrtForUpgrade: number;
    name: string;
    rejectUpgradeMessage?: string;
    resetMonthly: boolean;
    sumDaysStayInLevel: number;
    uniqueName: __Enum;
    upgradeRequestState: number;
    isWaitingForAdmin: boolean;
}

export enum __TransactionState {
    WaitingForPayment = 1,
    Done,
    Failed,
    WaitingForConfirmation,
    WaitingForOtpConfirmation,
    WaitingForAdminConfirmation,
    WaitingForNetworkPayout,
    Rejected,
    ManualDoing,
    Doing,
    ReadyToWithdraw,
    WaitingForTime,
}

export enum __TransactionType {
    Deposit = 1,
    Withdraw = 2,
    AffiliateDeposit,
    ReferralWithdrawal,
    Reward,
}

export enum __OrderTransactionState {
    Done = 1,
    WaitingForPayment = 2,
    WaitingForDestinationWithdraw = 3,
    WaitingForFirstPurchaseTime = 4,
    Rejected = 5,
    Paid = 6,
    WaitingForReceiptVerification = 7,
    WaitingForAdminConfirmation = 8,
    Doing = 9,
}
